import React, { useMemo } from "react";
import { Theme } from "./shared.types";
import { ThemeProvider } from "styled-components";
import { Themes } from "./colors";

type GameSheetThemeProps = {
  theme?: Partial<Theme>;
  children: any;
};

const defaultTheme = Themes.primary;

const GameSheetTheme = ({
  theme: partialTheme,
  children,
}: GameSheetThemeProps) => {
  const theme = useMemo(
    () => ({ ...defaultTheme, ...partialTheme }),
    [JSON.stringify(partialTheme)]
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default GameSheetTheme;
